import {useEffect} from 'react'
import analytics from '../../common/analytics/index.js'
import {showFeatureLockedModal} from '../Modals/FeatureLockedModal.js'
import {showUpgradeModal} from '../Modals/UpgradeModal.js'
import ButtonPrimary from '../../common/components/Button/ButtonPrimary.js'
import {usesAppsSelector} from '../../data/company.js'
import {useSelector} from '../../store.js'
import Icon from '../../common/icons/Icon.js'

export default function SalesChannelsFeaturePage() {
  const usesApps = useSelector(usesAppsSelector)
  useEffect(() => {
    analytics.trackEvent('sales_channels_feature_lock')
  }, [])

  return (
    <div className="alert alert--lg alert--warning-lt margin-top-20 margin-bottom-10 align-center">
      <Icon name="lock-closed" className="fs-04 op-30 lh-sm margin-bottom-0" />
      <p className="align-center fs-02 lh-md  margin-bottom-15">
        <strong>Get Your Time Back with Automated Inventory Writeback</strong>
      </p>
      {usesApps ? (
        <p className="fs-01 lh-lg margin-bottom-25">
          To gain access to{' '}
          <a
            className="btn btn--link darker border-underline v-align-base"
            href="https://support.ordoro.com/write-back-inventory-to-sales-channels/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>sales channel inventory writeback</span>
          </a>
          , you need to add the <strong>Inventory App</strong>.
        </p>
      ) : (
        <p className="fs-01 lh-lg margin-bottom-25">
          Upgrade your account with our{' '}
          <strong>Inventory Management Module</strong> to gain access to{' '}
          <a
            className="btn btn--link darker border-underline v-align-base"
            href="https://support.ordoro.com/write-back-inventory-to-sales-channels/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>sales channel inventory writeback</span>
          </a>{' '}
          and other related features.
        </p>
      )}

      <div className="margin-bottom-10">
        {usesApps ? (
          <ButtonPrimary
            size="x-md"
            className="meta--feature-lock-bom"
            alt
            onClick={() => showUpgradeModal()}
          >
            Manage Your Apps
          </ButtonPrimary>
        ) : (
          <ButtonPrimary
            size="x-md"
            className="meta--feature-lock-bom"
            alt
            onClick={() => showFeatureLockedModal('inventory')}
          >
            Get the Inventory Management Module
          </ButtonPrimary>
        )}
      </div>
    </div>
  )
}
